// React
import React from 'react';
import CybsSelect from '@cybs-ui/components/lib/select';
import '../css/rhs-header.css';
import {useSelector} from 'react-redux';
import { putDataInDevCenterDataStore, getDevCenterDataStore} from '../../../../../app/store';
import { getAllConfigurationData } from '../../../../../lhs/reducers/configuration-reducer';
import { setDefaultHTTPCredsInCookies, setDefaultJWTCredsInCookies, getCredCookie} from '../../../../../commons/cookie';
import { clearResponseFields } from '../../../../../lhs/actions/navigation-actions';
import { getHeaderCounter, getRequestHeaders} from '../../../reducers/rhs-schema-reducer';
import { getProcessorsList } from '../../../../../libs/common-library';

const ProcessorDropdown =(props) =>{
  var processor = useSelector(state => state.configurationReducer.processor);
  let disableProcessorDropDown  = useSelector(state =>  state.lhsReducer && state.lhsReducer.disableProcessorDropDown);
  var processorMap = useSelector(state => state.configurationReducer.processorMap);
  var processorListFromProcessorConfig = getProcessorsList();
  var modifiedProcessorMap = modifyMap(processorMap, processorListFromProcessorConfig);
  if (processorListFromProcessorConfig.length > 0) {
    if (!processorListFromProcessorConfig.includes(processor)) {
      processor = modifiedProcessorMap[0].value;
    }
  }

  var selectedItem = {value: processor, label: (processorMap != undefined)?processorMap.get(processor):''};
  const handleSelection = (event, selectedItem) => {
      if(selectedItem[0].value != undefined)
      {
        const currentAuthType = getDevCenterDataStore().getState().configurationReducer.currentAuthType || "";
        putDataInDevCenterDataStore({type:'UPDATE_PROCESSOR',processor:selectedItem[0].value});
         putDataInDevCenterDataStore({type:'UPDATE_PROCESSOR_NAME',processorName:selectedItem[0].label});
         var allProcessorData = getAllConfigurationData();
         var currentProcessorData = allProcessorData['processors'][selectedItem[0].value];
         storeProcessorAuthValuesInStore(currentProcessorData);
         if (currentAuthType === 'HTTP Signature') {
           setDefaultHTTPCredsInCookies();
         } else if (currentAuthType === 'Json Web Token') {
           setDefaultJWTCredsInCookies();
         }

          // Passing the selected Processor Type label to the parent component
          // i.e Authentication card to pass again this value to sample-request-dropdown.js
          props.onProcessorSelect(selectedItem[0].label);
      }
  }

  return[
   'boolean' === typeof disableProcessorDropDown && disableProcessorDropDown  ? <div></div>
       : <div class="ProcessorDropDownBar" id="processorInfo">
           <CybsSelect
               i18n={{
                   label: 'Payment Processor Type',
               }}
               dataTest="processor-type"
               items={modifiedProcessorMap}
               onSelect={handleSelection}
               selectedItems={[selectedItem]}
               colorScheme='primary'
           />
       </div>
  ]
}

function modifyMap(ProcessorMap, ProcessorListFromProcessorConfig)
{
  if (ProcessorMap != undefined) {
    var processorList = [];
    for (const [key, value] of ProcessorMap.entries()) {
      var element = { 'value': key, 'label': value };
      if (ProcessorListFromProcessorConfig.length > 0) {
        if (ProcessorListFromProcessorConfig.includes(key)) {
          processorList.push(element);
        }
      } else {
        processorList.push(element);
      }
    }
    return processorList;
  }
  return null;
}

function storeProcessorAuthValuesInStore(currentProcessorData) {
  const processorName = currentProcessorData.processor || "";
  const isVisaPlatformConnect = processorName === "Visa Platform Connect Certification Testing";
  const currentAuthType = getDevCenterDataStore().getState().configurationReducer.currentAuthType || "";

  //VPCCT Case
  if (isVisaPlatformConnect) {
    // Check for custom HTTP credentials
    if (currentAuthType === 'HTTP Signature') {
      const customMerchantId = getCredCookie("merchantId");
      const customKeyId = getCredCookie("key");
      const customSecretKey = getCredCookie("secretKey");
      const defaultMerchant = getDevCenterDataStore().getState().configurationReducer.defaultMerchant;
      // If custom credentials exist and were being used (checked by the defaultMerchant flag)
      if (defaultMerchant === false && customMerchantId && customKeyId && customSecretKey) {
        putDataInDevCenterDataStore({ type: 'UPDATE_MERCHANT_ID', merchantId: customMerchantId });
        putDataInDevCenterDataStore({ type: 'UPDATE_KEY_ID', keyId: customKeyId });
        putDataInDevCenterDataStore({ type: 'UPDATE_SECRET_KEY', secretKey: customSecretKey });
        putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_PARAM_DEFAULTS', headerParamDefaults: currentProcessorData["headerParamDefaults"] });

        updateRequestHeadersMerchantId(customMerchantId);
      } else {
        putDataInDevCenterDataStore({ type: 'UPDATE_MERCHANT_ID', merchantId: currentProcessorData["merchantId"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_KEY_ID', keyId: currentProcessorData["authentication"]["httpSignature"]["keyId"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_SECRET_KEY', secretKey: currentProcessorData["authentication"]["httpSignature"]["secretKey"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_PARAM_DEFAULTS', headerParamDefaults: currentProcessorData["headerParamDefaults"] });

        updateRequestHeadersMerchantId(currentProcessorData["merchantId"]);
      }
    }
    // Check for custom JWT credentials
    else if (currentAuthType === 'Json Web Token') {
      const customJwtMerchantId = getCredCookie("jwtMerchantId");
      const jwtToken = sessionStorage.getItem('jwttoken');
      const defaultMerchant = getDevCenterDataStore().getState().configurationReducer.defaultMerchant;
      // If custom JWT credentials exist and were being used
      if (defaultMerchant === false && customJwtMerchantId && jwtToken) {
        putDataInDevCenterDataStore({ type: 'UPDATE_MERCHANT_ID', merchantId: customJwtMerchantId });
        putDataInDevCenterDataStore({ type: 'UPDATE_P12KEY', p12Key: jwtToken });
        putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_PARAM_DEFAULTS', headerParamDefaults: currentProcessorData["headerParamDefaults"] });

        updateRequestHeadersMerchantId(customJwtMerchantId);
      }
      else {
        putDataInDevCenterDataStore({ type: 'UPDATE_MERCHANT_ID', merchantId: currentProcessorData["merchantId"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_P12KEY', p12Key: currentProcessorData["authentication"]["jwt"]["p12Key"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_PARAM_DEFAULTS', headerParamDefaults: currentProcessorData["headerParamDefaults"] });

        updateRequestHeadersMerchantId(currentProcessorData["merchantId"]);
      }
    }
  }
  else {
    // Non VPCCT Case
    putDataInDevCenterDataStore({ type: 'UPDATE_MERCHANT_ID', merchantId: currentProcessorData["merchantId"] });
    putDataInDevCenterDataStore({ type: 'UPDATE_KEY_ID', keyId: currentProcessorData["authentication"]["httpSignature"]["keyId"] });
    putDataInDevCenterDataStore({ type: 'UPDATE_SECRET_KEY', secretKey: currentProcessorData["authentication"]["httpSignature"]["secretKey"] });
    putDataInDevCenterDataStore({ type: 'UPDATE_P12KEY', p12Key: currentProcessorData["authentication"]["jwt"]["p12Key"] });
    putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_PARAM_DEFAULTS', headerParamDefaults: currentProcessorData["headerParamDefaults"] });
    putDataInDevCenterDataStore({ type: 'UPDATE_DEFAULT_MERCHANT', defaultMerchant: true });

    updateRequestHeadersMerchantId(currentProcessorData["merchantId"]);
  }
}

function updateRequestHeadersMerchantId(merchantId) {
  //Update Request Header code
  var requestHeaders = getRequestHeaders();
  if (requestHeaders && 'v-c-merchantId' in requestHeaders) {
    requestHeaders['v-c-merchantId'] = merchantId;
    putDataInDevCenterDataStore({ type: "UPDATE_REQUEST_HEADERS", requestHeaders: requestHeaders });

    let headerCounter = getHeaderCounter();
    if (headerCounter == undefined) {
      putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_COUNTER', headerCounter: 0 });
    } else {
      putDataInDevCenterDataStore({ type: 'UPDATE_HEADER_COUNTER', headerCounter: ++headerCounter });
    }
  }
}

export { storeProcessorAuthValuesInStore, updateRequestHeadersMerchantId, modifyMap };
export default ProcessorDropdown;
